import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./UnauthorizedAccessModal.scss";
import { LockOutlined } from "../../../helpers/icons/antDesignIcons";
import useTranslation from "../../../hooks/useTranslation";

/**
 * Modal component that displays when a user tries to access a resource they don't have permission for
 *
 * @param {boolean} show - Controls visibility of the modal
 * @param {Function} onDismiss - Handler function called when modal is dismissed
 * @param {string} resourceType - Type of resource being accessed (for translation)
 * @param {string} customMessage - Optional custom message to display instead of default
 */

const UnauthorizedAccessModal = ({
  show,
  onDismiss,
  resourceType = "resource",
  customMessage = null,
}) => {
  const { t } = useTranslation("common");

  const handleRedirect = () => {
    onDismiss();
  };

  return (
    <Modal
      show={show}
      onHide={onDismiss}
      centered
      backdrop="static"
      className="unauthorized-access-modal"
    >
      <Modal.Header>
        <Modal.Title>
          <LockOutlined className="unauthorized-access-modal__icon" />
          {t("unauthorizedAccess")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {customMessage || <p>{t("unauthorizedAccessMessage")}</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleRedirect}>
          {t("back")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UnauthorizedAccessModal;
